// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"9e91db8c","208":"3e53a261","453":"8701dc61","669":"1d167d57","718":"38ac3573"}[chunkId] + ".chunk.js";
};